import Sidebar from 'components/layout/Sidebar';
import userActions from 'features/user/services/actions';
import moment from 'moment';
import React, { useEffect } from 'react';
import uiActions from 'services/UI/actions';
import shopActions from 'services/shop/actions';
import { useAppDispatch } from 'store/hooks';
import Main from './components/Main';
import ClockInClockOutPageStyled from './styles';
import { useSocketContext } from 'hooks/useSocket';
import multiplePaymentActions from 'features/payment/pages/PaymentPage/services/actions';
import { ticketListUIActions } from 'features/ticketList/services/reducers';
import CustomerEditor from 'features/user/widgets/WaitingList/CustomerEditor';
type IClockInClockOutPageProps = any;
const ClockInClockOutPage: React.FC<IClockInClockOutPageProps> = () => {
  const dispatch = useAppDispatch();
  const socket = useSocketContext();
  useEffect(() => {
    dispatch(userActions.getNotifications.fetch());
    dispatch(ticketListUIActions.setIsVerifyKeyIn(false));
    dispatch(userActions.activeRemoveTicket(false));
    dispatch(userActions.doFilterData({}));
    dispatch(userActions.getWaitingList.fetch());
    dispatch(userActions.getAppointmentToday.fetch());
    dispatch(userActions.getListAvailableWorking.fetch());
    dispatch(userActions.getBillWaitingTicket.fetch());
    dispatch(shopActions.get.staffsAvailable.fetch());
    dispatch(userActions.refreshMergeTicket());
    dispatch(multiplePaymentActions.customerSide.setCustomerMsg.fetch(null));
    dispatch(multiplePaymentActions.customerSide.setReceiveConfigs(null));
    dispatch(userActions.getHomeBackground.fetch());
    socket.unsubscribePassData();
    // @ts-ignore
    document.body.style.zoom = '100%';
    const countdown = setInterval(() => {
      dispatch(uiActions.setCurrentTime(moment().format()));
    }, 30000);
    return () => {
      clearInterval(countdown);
    };
  }, []);

  return (
    <ClockInClockOutPageStyled>
      <Sidebar />
      <Main />
      <CustomerEditor />
    </ClockInClockOutPageStyled>
  );
};

export default ClockInClockOutPage;

